export const ALL_MONTHS_VALUE = 'all'
export const ALL_MONTHS_OPTION = { value: ALL_MONTHS_VALUE, label: 'All' }

const MONTH_LABELS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

export function formatMonthLabel(value) {
  if (!value) return ''
  const [yearStr, monthStr] = value.split('-')
  const monthIndex = parseInt(monthStr, 10) - 1
  const name = MONTH_LABELS[monthIndex]
  if (!name || !yearStr) return ''
  return `${name} ${yearStr}`
}

export function ymToOption(value) {
  return { value, label: formatMonthLabel(value) }
}

export function currentYearMonth() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
}

export function sortedDescending(months) {
  return months.slice().sort((a, b) => b.localeCompare(a))
}
